module.exports = __webpack_public_path__ + "img/pro_five_1.db9bc0ae.jpg";